// dependencies
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

// Project
import get from "../../utils/GetNested";
import serializeObject from "../../utils/SerializeObject";

/**
 * Get user permissions for a domain.
 */
export const GetDomainPermissions = CreateProcess({
	method: "GET",
	name: "GetDomainPermissions",
	type: "PERMISSIONS:GETDOMAIN",

	request: (props) => ({
		url: `/api/permissions/${props.domain}/`,
	}),

	success: (response) => fromJS(response.data),
});

/**
 * Get user permissions for a specific object in a domain.
 */
export const GetObjectPermissions = CreateProcess({
	method: "GET",
	name: "GetObjectPermissions",
	type: "PERMISSIONS:GETOBJECT",

	request: (props) => {
		const { domain, objectName, objectValue } = props;
		const serializedObject = serializeObject({ [objectName]: objectValue }, true, { arrayKeySuffix: "" });
		return {
			url: `/api/permissions/${domain}/?${serializedObject}`,
		};
	},

	success: (response) => fromJS(response.data),
});

export const GetRbacEmployeePermissions = CreateProcess({
	method: "GET",
	name: "GetRbacEmployeePermissions",
	type: "PERMISSIONS:GetRBACEMPLOYEE",

	request: (props) => {
		const { employeeID } = props;

		return {
			url: `/api/rbac/permissions/employee/${employeeID}`,
		};
	},

	success: (response) => {
		const { data } = response;
		return get(data, ["user_permissions"], []);
	},
});

export const GetRbacDomainPermissions = CreateProcess({
	method: "GET",
	name: "GetRbacDomainPermissions",
	type: "PERMISSIONS:GetRbacDomainPermissions",

	request: (props) => {
		const { objectType = null } = props.params;

		if (objectType) {
			return {
				url: `/api/rbac/permissions/?object_type=${objectType}`,
			};
		}

		return {
			url: `/api/rbac/permissions/`,
		};
	},

	success: (response) => {
		const { data } = response;
		return get(data, ["user_permissions"], []);
	},
});
